var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5618 13H8.56177C8.56177 15.2091 10.3526 17 12.5618 17C14.7709 17 16.5618 15.2091 16.5618 13Z",
    fill: "#00BAF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56177 12C2.56177 6.47715 7.03892 2 12.5618 2C18.0846 2 22.5618 6.47715 22.5618 12C22.5618 17.5228 18.0846 22 12.5618 22H2.56177L5.4907 19.0711C3.68106 17.2614 2.56177 14.7614 2.56177 12ZM7.3902 20H12.5618C16.9801 20 20.5618 16.4183 20.5618 12C20.5618 7.58172 16.9801 4 12.5618 4C8.14349 4 4.56177 7.58172 4.56177 12C4.56177 14.1524 5.41301 16.1649 6.90492 17.6569L8.31913 19.0711L7.3902 20Z",
    fill: "#002970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2900d05ac3b8faf1d6f7f1576402628a.svg";
export { ForwardRef as ReactComponent };